import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

import UserModule from "./modules/UserModul";
import UIModul from "./modules/UIModul";
import IGViralFinderModul from "./modules/IGViralFinderModul";

Vue.use(Vuex);
import createPersistedState from "vuex-persistedstate";
export default new Vuex.Store({
  state: {
    fbAuth: {},
    fbAuthUrl: "",
    loginRedirectUrl: "",
  },
  mutations: {
    fb_auth_request_success(state, response) {
      state.fbAuth = response;
    },
    set_login_redirect_url(state, payload) {
      state.loginRedirectUrl = payload;
    },
    set_fb_url(state, payload) {
      state.fbAuthUrl = payload.authUrl;
    },
  },
  actions: {
    checkFbAuth({ commit }, code) {
      return new Promise((resolve, reject) => {
        commit("ui/is_loading", true);
        axios({
          url: "/user/facebook/facebookAuth?code=" + code,
          method: "GET",
        })
          .then((resp) => {
            const fbAuth = resp.data;
            commit("ui/is_loading", false);
            commit("fb_auth_request_success", fbAuth);
            resolve(resp);
          })
          .catch((err) => {
            commit("ui/is_loading", false);
            //localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    getFbAuthUrl({ commit }) {
      return new Promise((resolve, reject) => {
        commit("ui/is_loading", true);
        axios({
          url: "/user/facebook/auth?type=none",
          method: "GET",
        })
          .then((resp) => {
            const fbAuth = resp.data;
            commit("ui/is_loading", false);
            commit("set_fb_url", fbAuth);
            resolve(resp);
          })
          .catch((err) => {
            commit("ui/is_loading", false);
            //localStorage.removeItem("token");
            reject(err);
          });
      });
    },
  },
  getters: {
    loginRedirectUrl: (state) => state.loginRedirectUrl,
    fbAuthUrl: (state) => state.fbAuthUrl,
  },
  modules: {
    user: UserModule,
    ui: UIModul,
    igViralFinder: IGViralFinderModul,
  },
  plugins: [
    createPersistedState({
      paths: ["user", "ui"],
    }),
  ],
});
